const commonConstants = {
    api_url: process.env.VUE_APP_API_KEY,
    ai_service_api_url: process.env.VUE_APP_AI_SERVICE_API_URL,
    ai_service_api_key: process.env.VUE_APP_AI_SERVICE_API_KEY,
    process: process,
    env: process.env,

}
export default commonConstants ;
